import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFaceFrown } from '@fortawesome/free-solid-svg-icons'
import styles from './index.module.scss'
import linkStyles from '~/components/Link/index.module.scss'

interface LinkProps {
  href?: string
}

export const CollectionsErrorState: React.FC<LinkProps> = ({ href }) => {
  return (
    <div className={ styles['series-collections-error-state__container'] }>
      <div className={ styles['series-collections-error-state__card'] }>
        <FontAwesomeIcon
          className={ styles['series-collections-error-state__icon'] }
          icon={ faFaceFrown }
        />

        <strong className={ styles['series-collections-error-state__title'] }>
          Ups! Something went wrong.
        </strong>

        <span className={ styles['series-collections-error-state__description'] }>
          It seems there was a problem and we couldn&apos;t load this data. Please try again.
        </span>

        <a
          className={ `
            ${styles['series-collections-error-state__link']}
            ${linkStyles['link']}
          ` }
          data-testid="retry-link"
          href={ href }
          rel="noreferrer"
        >
          Retry
        </a>
      </div>
    </div>
  )
}
